import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { RoleGate } from '@oceanjs/core';
import { IHeaderDropdownProps } from '@oceanjs/ui-bootstrap-header';

export type HeaderDropdownProps = Omit<IHeaderDropdownProps, 'icon'> & {
  icon?: IconDefinition;
  onRenderIcon?: () => ReactNode;
}

export const HeaderDropdown: React.FC<HeaderDropdownProps> = (
  props: Readonly<HeaderDropdownProps>
): JSX.Element => {
  const { id, icon, onRenderIcon, messageId, children, userRole, ...attributes } = props;

  return (
    <RoleGate userRole={userRole}>
      <UncontrolledDropdown {...attributes} nav inNavbar>
        <DropdownToggle id={id} nav caret>
          {onRenderIcon && onRenderIcon()}
          {icon && <FontAwesomeIcon fixedWidth icon={icon} className="mr-1" />}
          <FormattedMessage id={messageId || id} />
        </DropdownToggle>
        <DropdownMenu>{children}</DropdownMenu>
      </UncontrolledDropdown>
    </RoleGate>
  );
};

HeaderDropdown.displayName = 'HeaderDropdown';
